import {
  minUsernameLength,
  maxUsernameLength,
  minPasswordLength,
  maxPasswordLength,
  SPECIAL_CHAR_REGEX,
  NO_LEADING_TRAILING_SPACE,
  CONTAINS_SPACE,
} from 'constants/constants';

export const actionTypes = {
  UPDATE_AND_VALIDATE_FIELD: 'UPDATE_AND_VALIDATE_FIELD',
  VALIDATE_ALL_FIELDS: 'VALIDATE_ALL_FIELDS',
  USERNAME_TAKEN: 'USERNAME_TAKEN',
};

export const initialFormFields = [
  {
    label: 'Username',
    description: 'Choose a memorable username to use each time you sign in',
    id: 'username',
    value: '',
    type: 'text',
    className: 'mt-18',
    error: '',
  },
  {
    label: 'Password',
    id: 'password',
    value: '',
    type: 'password',
    className: 'mt-26',
    error: '',
  },
  {
    label: 'Confirm password',
    id: 'confirmPassword',
    value: '',
    type: 'password',
    className: 'mt-26',
    error: '',
  },
];

// Error handler for all form fields
const validateField = (id, value, formFields) => {
  let errorMsg = '';
  const password = formFields?.find(field => field.id === 'password');

  switch (id) {
    case 'username':
      if (!value) {
        errorMsg = 'Please enter a username';
      } else if (
        value.length < minUsernameLength ||
        value.length > maxUsernameLength
      ) {
        errorMsg = `Usernames must be ${minUsernameLength} - ${maxUsernameLength} characters long`;
      } else if (
        !NO_LEADING_TRAILING_SPACE.test(value) ||
        CONTAINS_SPACE.test(value)
      ) {
        errorMsg = 'Your username cannot include spaces';
      } else if (!SPECIAL_CHAR_REGEX.test(value)) {
        errorMsg = 'Your username can only include letters, numbers and .-_@,';
      }
      break;
    case 'password':
      if (!value) {
        errorMsg = 'Please enter a password';
      } else if (
        value.length < minPasswordLength ||
        value.length > maxPasswordLength
      ) {
        errorMsg = `Your password must be ${minPasswordLength} - ${maxPasswordLength} characters long`;
      } else if (!NO_LEADING_TRAILING_SPACE.test(value)) {
        errorMsg = 'Your password cannot have spaces at the start or end';
      }
      break;
    case 'confirmPassword':
      if (!value || value !== password?.value) {
        errorMsg = 'The passwords entered do not match';
      }
      break;
    default:
      break;
  }

  return errorMsg;
};

const { UPDATE_AND_VALIDATE_FIELD, VALIDATE_ALL_FIELDS, USERNAME_TAKEN } =
  actionTypes;

export const reducer = (state, action) => {
  switch (action.type) {
    case UPDATE_AND_VALIDATE_FIELD:
      return state.map((field, index) =>
        index === action.payload.index
          ? {
              ...field,
              error: validateField(field.id, action.payload.value, state),
              value: action.payload.value,
            }
          : field,
      );
    case VALIDATE_ALL_FIELDS:
      return state.map(field => {
        const errorMsg = validateField(field.id, field.value, state);
        return { ...field, error: errorMsg };
      });
    case USERNAME_TAKEN:
      return state.map((field, index) =>
        index === 0
          ? {
              ...field,
              error: action.payload,
            }
          : field,
      );
    default:
      return state;
  }
};
